var hashtag_default = {
  "fontElementMap": "UvT8O",
  "hashtag": "_4Cq4U"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
